import { privateDico } from "@/assets/dico/privateDico";
import { forEach, intersection } from "lodash";

const dico = privateDico.convention.csps;

class SectionsManager {
    /**
     *
     * @param container
     * @param availableCSPCodes
     */
    commonLegends(container, availableCSPCodes, ccBodySelector) {
        const ccBody = container.querySelectorAll(`${ccBodySelector}`);
        forEach(ccBody, element => {
            if (!element.classList.contains("common-legends")) {
                if (element.classList.contains("note-di")) {
                    element.classList.add("csp-di");
                }
                if (intersection(availableCSPCodes, element.classList).length == 0) {
                    element.classList.add("common-legends");
                    forEach(availableCSPCodes, cspCode => element.classList.add(cspCode));
                }
            }
        });
    }

    /**
     *
     * @param container
     * @param availableCSPCodes
     */
    cspTitleTags(container, availableCSPCodes) {
        const sections = container.querySelectorAll(".convention-section");
        forEach(sections, section => {
            const cspClasses = [];
            const title = section.querySelector(".typo");
            this.removeCSPClasses(title);
            forEach(availableCSPCodes, code => {
                const element = section.querySelector(`.${code}`);
                if (element) {
                    cspClasses.push(code);
                }
            });
            forEach(cspClasses, code => title.classList.add(code));
        });
    }

    removeCSPClasses(el) {
        const regex = new RegExp("\\bcsp-.+?\\b", "g");
        if (el) {
            el.className = el.className.replace(regex, "");
        }
        return el;
    }

    /**
     *
     * @param container
     * @param csps
     */
    cspLines(container, availableCSPCodes) {
        forEach(availableCSPCodes, cspCode => {
            const elements = container.querySelectorAll(`.${cspCode}`);
            forEach(elements, e => this._cspLine(e, cspCode));
        });
    }

    removeAllLines(container) {
        const elements = container.getElementsByClassName("cc-legend") || [];
        elements.forEach(element => element.remove());
    }

    /**
     *
     * @param cspFilters
     */
    filterSections(container, cspFilters) {
        // Manage content
        const elements = container.querySelectorAll(".csp");

        forEach(elements, e => {
            const active = this._isCspActive(e, cspFilters);
            const display = e.tagName == "TABLE" ? "table" : "block";
            e.style.display = active ? display : "none";
        });

        // Manage legend
        const legendElements = container.querySelectorAll(".cc-legend");

        forEach(legendElements, e => {
            const cspCode = e.getAttribute("cspCode");
            const active = cspFilters.indexOf(cspCode) > -1;
            e.style.display = active ? "block" : "none";
        });

        // Manage Note DI
        const noteDiElements = container.querySelectorAll(".convention-section-note-di");

        forEach(noteDiElements, e => {
            const active = cspFilters.indexOf("csp-di") > -1;
            e.style.display = active ? "block" : "none";
        });
    }

    _cspLine(element, cspCode) {
        if (!element.querySelector(`.cc-${cspCode}`)) {
            const div = document.createElement("div");
            element.classList.add("csp");
            div.classList.add(`cc-${cspCode}`);
            div.classList.add(`cc-legend`);
            div.setAttribute("cspCode", cspCode);
            div.style.backgroundColor = dico[cspCode].color;
            element.append(div);
        }
    }

    _isCspActive(element, cspFilters) {
        const classes = Array.from(element.classList);
        const result = intersection(classes, cspFilters);
        return result.length;
    }
}

const sectionsManager = new SectionsManager();
export default sectionsManager;
